// Msg 419 (2026-08-31, Farhod tog'a): eski implementatsiya BUTUN satrni
// (kasr va minus bilan birga) teskari qilib har 3 belgidan bo'lardi —
// "32638.600" -> "326 38. 600" bo'lib chiqardi. To'g'risi: faqat BUTUN
// qismni O'NGDAN guruhlash, ishora va kasr saqlanadi: "-17361.400" -> "-17 361,400".
export default function formatStringToNumber(
  num: number | string,
  symbol = " "
) {
  const s = String(num ?? "").trim()
  const m = s.match(/^(-?)(\d+)(?:[.,](\d+))?$/)
  if (!m) return s // raqam bo'lmagan qiymatlarga tegilmaydi
  const sign = m[1]
  const grouped = m[2].replace(/\B(?=(\d{3})+(?!\d))/g, symbol)
  const dec = m[3]
  return sign + grouped + (dec != null ? "," + dec : "")
}
